import { render, staticRenderFns } from "./DestinationListSelectTable.vue?vue&type=template&id=482b0af0&scoped=true"
import script from "./DestinationListSelectTable.vue?vue&type=script&lang=ts"
export * from "./DestinationListSelectTable.vue?vue&type=script&lang=ts"
import style0 from "./DestinationListSelectTable.vue?vue&type=style&index=0&id=482b0af0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482b0af0",
  null
  
)

export default component.exports